module.exports = __webpack_public_path__ + "static/avantages_vehicles-f59c51d62426685b91806bb34902280e.svg";